import { useEffect, useRef, useState } from 'react';
import { v4 as uuid4 } from 'uuid';
import { createPortal } from 'react-dom';

import { NsAnchor } from 'components/common/ns-anchor/NsAnchor';
import { useScreen } from 'hooks/useScreen';

type NsCaveatLinkProps = {
  children?: React.ReactNode;
  caveatId?: string;
};

export const NsCaveatLink = ({
  children,
  caveatId /* refferencing existing caveat */
}: NsCaveatLinkProps) => {
  const refId = useRef(caveatId ?? uuid4());
  const { caveatRef, caveatItemIdsRef } = useScreen();
  const [index, setIndex] = useState<number | null>(null);
  const [shouldCreateCaveat, setShouldCreateCaveat] = useState(false);

  useEffect(() => {
    const caveatId = refId.current;
    const caveatItemIds = caveatItemIdsRef;
    const shouldRegisterCaveatLink =
      refId?.current &&
      caveatItemIdsRef.current &&
      !caveatItemIdsRef.current?.includes(refId.current);

    if (shouldRegisterCaveatLink) {
      caveatItemIdsRef.current = [...caveatItemIdsRef.current, refId.current];
      setShouldCreateCaveat(true);
    }

    return () => {
      caveatItemIds.current = caveatItemIds.current?.filter(
        (id) => id !== caveatId
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // watch for changes in registered caveat links
    setIndex(caveatItemIdsRef.current?.indexOf(refId.current) + 1);
  });

  return (
    <NsAnchor href="#caveat">
      <>
        {index}
        {shouldCreateCaveat &&
          caveatRef &&
          createPortal(
            <li id={refId.current}>{children}</li>,
            caveatRef,
            JSON.stringify(caveatItemIdsRef.current)
          )}
      </>
    </NsAnchor>
  );
};
